import React from "react";

const ModalTooLongContent = props => {
	return <div className="modal-too-long-content">{props.children}</div>;
};

export default ModalTooLongContent;
